import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";
import { videoTypes } from "@/mocks/categories";
import VideoCard from "@/components/base/VideoCard";
import SectionTitle from "@/components/base/SectionTitle";

export default function VideosPage() {
  const [type, setType] = useState("all");
  const [sort, setSort] = useState<"latest" | "hot">("latest");
  const [visible, setVisible] = useState(6);

  const filtered = useMemo(() => {
    let list = type === "all" ? videos : videos.filter((v) => v.type === type);
    list = [...list].sort((a, b) => (sort === "hot" ? b.views - a.views : b.date.localeCompare(a.date)));
    return list;
  }, [type, sort]);

  const shown = filtered.slice(0, visible);

  return (
    <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-10">
      <nav className="mb-6 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
        <Link to="/" className="transition-colors hover:text-primary-400">
          首页
        </Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-800">视频资源</span>
      </nav>

      <div className="mb-8 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
        <SectionTitle
          eyebrow="VIDEO LIBRARY"
          title="精彩视频集"
          desc="影视剧、综艺与短视频精选合集，封面信息清晰，一键进入视频详情页。"
        />
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-200 px-1 py-1">
            {videoTypes.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => {
                  setType(t.key);
                  setVisible(6);
                }}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  type === t.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {t.name}
              </button>
            ))}
          </div>
          <div className="flex items-center gap-1 rounded-full border border-background-200 px-1 py-1">
            {[
              { key: "latest", label: "最新" },
              { key: "hot", label: "最热" },
            ].map((s) => (
              <button
                key={s.key}
                type="button"
                onClick={() => {
                  setSort(s.key as "latest" | "hot");
                  setVisible(6);
                }}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  sort === s.key
                    ? "bg-accent-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {s.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {shown.length > 0 ? (
        <>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {shown.map((v) => (
              <VideoCard key={v.id} item={v} />
            ))}
          </div>
          {visible < filtered.length && (
            <div className="mt-8 flex justify-center">
              <button
                type="button"
                onClick={() => setVisible((v) => v + 6)}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 px-6 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-400"
              >
                加载更多 <i className="ri-arrow-down-line"></i>
              </button>
            </div>
          )}
          {visible >= filtered.length && filtered.length > 0 && (
            <p className="mt-8 text-center text-xs text-foreground-500">已加载全部视频</p>
          )}
        </>
      ) : (
        <div className="flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-100 py-16">
          <i className="ri-video-off-line text-4xl text-foreground-400"></i>
          <p className="text-sm text-foreground-600">该分类下暂无视频。</p>
        </div>
      )}
    </div>
  );
}